import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useAccountStore} from "@domains/account/stores/account.store";

export const getGeneralInfoResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const accountStore = useAccountStore();
    accountStore.loadGeneralInfo().then(() => next());

};
